module.exports = __webpack_public_path__ + "static/the-precipice-477dc830a1528826f0c522e44b04fdee.jpg";